import React, { Component } from 'react';
import CloseablePage from 'containers/CloseablePage';
import NotificationWindow from 'components/NotificationWindow';
import CompletePasswordResetWithData from 'components/CompletePasswordReset/CompletePasswordResetWithData';
import { compose, graphql, withApollo } from 'react-apollo/index';
import gql from 'graphql-tag';
import {
  ERROR_SERVER_ERROR,
  GLOBAL_MESSAGES,
  GLOBAL_RESET_PASSWORD_TOKEN_INVALID
} from '../../utils/constants';

const resetPasswordValidationQuery = gql`
  mutation MyIsPasswordResetTokenValid($resetToken: String!) {
    isPasswordResetTokenValid(resetToken: $resetToken)
  }
`;

class CompletePasswordResetPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: null,
      tokenValid: false,
      tokenInvalidReason: ''
    };
  }

  componentDidMount() {
    if (
      this.props &&
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.token
    ) {
      let token = this.props.match.params.token;

      this.props
        .validateToken(token)
        .then(res => {
          if (res && res.data) {
            if (res.data.isPasswordResetTokenValid) {
              this.setState({
                resetToken: token,
                tokenValid: true
              });
            } else {
              this.setState({
                tokenValid: false,
                tokenInvalidReason:
                  GLOBAL_MESSAGES[GLOBAL_RESET_PASSWORD_TOKEN_INVALID]
              });
            }
          } else {
            this.setState({
              tokenValid: false,
              tokenInvalidReason: ERROR_SERVER_ERROR
            });
          }
        })
        .catch(() => {
          this.setState({
            tokenValid: false,
            tokenInvalidReason: ERROR_SERVER_ERROR
          });
        });
    }
  }

  render() {
    return (
      <CloseablePage>
        {this.state.tokenValid ? (
          <CompletePasswordResetWithData resetToken={this.state.resetToken} />
        ) : (
          <NotificationWindow message={this.state.tokenInvalidReason} />
        )}
      </CloseablePage>
    );
  }
}

export default withApollo(
  compose(
    graphql(resetPasswordValidationQuery, {
      props({ ownProps, mutate }) {
        return {
          validateToken: resetToken => {
            return mutate({
              variables: {
                resetToken: resetToken
              }
            });
          }
        };
      },
      options: {
        errorPolicy: 'all'
      }
    })
  )(CompletePasswordResetPage)
);



// WEBPACK FOOTER //
// ./src/containers/CompletePasswordResetPage/index.js